import { useState } from 'react';
import { Title } from 'components/Title';

import AddMandate from "./AddMandate"
export default function CreatemandatePage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="CreatemandatePage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="CreateMandate"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div>
                        <AddMandate/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
		</main>
	);
}
